module.exports = __webpack_public_path__ + "static/media/pic5.4b48127a.jpg";